
import { defineComponent } from 'vue';
import store from '@/store';
import { UserModel } from '@/interfaces/users/user.model';
import { GlobalPagination } from '@/interfaces/panel/global-pagination.model';

export default defineComponent({
    name: 'UsersListPage',

    data() {
        return {
            user: '',
            activeFilterButton: 'notification',
            buttons: [
                { title: 'نوتیفیکیشن', value: 'notification' },
                { title: 'پیامک (به‌زودی)', value: 'sms', disabled: true },
            ],
            notificationType: '',
            notificationMessage: '',
            notificationOptions: [
                { title: 'همه کاربران', value: 'ALL' },
                { title: 'کاربران احراز شده', value: 'VERIFIED' },
                { title: 'کاربران احراز نشده', value: 'NOT-VERIFIED' },
            ],
        };
    },
    computed: {
        getLoadingPanel(): boolean {
            return store.getters['panel/getLoadingPanel'];
        },
        getAllUsers(): UserModel[] {
            return store.getters['panel/getAllUsers'];
        },
        getGlobalPagination(): GlobalPagination {
            return store.getters['panel/getGlobalPagination'];
        },
    },
    methods: {
        back(): void {
            this.$emit('back');
        },
        handelPagination() {
            store.dispatch('panel/getAllUsersRequest', {
                type: this.activeFilterButton,
                search: this.search,
            });
        },
        setFilterOfUsersList(type: string): void {
            this.activeFilterButton = type;
        },
        performSearch(): void {
            store.dispatch('panel/getAllUsersRequest', {
                type: this.activeFilterButton,
                filters: this.search,
            });
        },
        toggleAccessAccount(user: { userId: string; block: boolean }): void {
            store.dispatch('panel/userAccessAccountRequest', user);
        },
        toggleUserCashout(user: { userId: string; cashout: boolean }): void {
            store.dispatch('panel/userCashOutRequest', user);
        },
        togglePanelAccess(user: { userId: string; access: boolean }): void {
            store.dispatch('panel/userPanelAccessRequest', user);
        },

        handleNotificationTypeChange(): void {
            this.activeFilterButton = 'notification';
        },
        submitNotification(): void {
            if (!this.notificationMessage.trim() || (!this.user && !this.notificationType)) {
                return;
            }
            let notificationData = {
                type: this.notificationType,
                message: this.notificationMessage
            };

            if (this.user) {
                const notification = {
                    message: 'پیام سیستم',
                    type: 'ADMIN',
                    desc: notificationData.message,
                    user: this.user,
                    metadata: {}
                }
                store.dispatch('panel/sendUserNotificationRequest', notification)
                    .then(() => {
                        this.notificationMessage = '';
                        this.notificationType = '';
                    })
                    .catch((error) => {
                        console.error('Error sending notification:', error);
                    });
            } else {
                store.dispatch('panel/sendNotificationRequest', notificationData)
                    .then(() => {
                        this.notificationMessage = '';
                        this.notificationType = '';
                    })
                    .catch((error) => {
                        console.error('Error sending notification:', error);
                    });
            }

        },
    },

    created() {
        const targetUser = this.$route.query.user;
        if (targetUser) {
            this.user = String(targetUser);
        } else {
            this.user = '';
        }
    }
});
